import { Link, useLocation } from 'react-router-dom'
import { User, FileText, Settings, BarChart3 } from 'lucide-react'

const DashboardLayout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()

  const navItems = [
    { path: '/dashboard', label: '대시보드', icon: BarChart3 },
    { path: '/dashboard/profile', label: '내 정보', icon: User },
    { path: '/dashboard/numbers', label: '내 번호', icon: FileText },
    { path: '/dashboard/subscription', label: '구독 관리', icon: Settings },
  ]

  const isActive = (path: string) => {
    if (path === '/dashboard') {
      return location.pathname === '/dashboard'
    }
    return location.pathname.startsWith(path)
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 py-8 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Sidebar Navigation */}
          <div className="lg:col-span-1">
            <div className="bg-white dark:bg-gray-900 rounded-lg shadow dark:shadow-none dark:border dark:border-gray-800 p-4 sticky top-24">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4 px-2">메뉴</h2>
              <nav className="space-y-1">
                {navItems.map((item) => {
                  const Icon = item.icon
                  const active = isActive(item.path)
                  
                  return (
                    <Link
                      key={item.path}
                      to={item.path}
                      className={`
                        flex items-center space-x-3 px-3 py-2 rounded-lg transition-colors
                        ${active 
                          ? 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 font-medium' 
                          : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800'
                        }
                      `}
                    >
                      <Icon className="w-5 h-5" />
                      <span>{item.label}</span>
                    </Link>
                  )
                })}
              </nav>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3">
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardLayout

